import { isEditorX } from '../../utils/editorx';
export const defaultSettings = {
  apiUrl: isEditorX ? 'https://pix.editorx.com' : 'https://pix.wix.com',
  apiPath: '/services/dribble',
  itemsLimit: 50
};